<template>
  <div>
    <div class="titles">
      编辑权限
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">名称：</div>
        <Input v-model="name" placeholder="请输入顶级权限名称..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">图标：</div>
        <Input v-model="icon" placeholder="请输入顶级权限名称..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div class="qx06">
      <div class="qx07">
        <div class="qx08">顺序：</div>
        <Input v-model="order" placeholder="请输入顶级权限顺序..." style="width: 300px;height: 60px !important;" class="qx09"/>
      </div>
    </div>
    <div style="width: 100%;display: flex;justify-content: center">
      <Button type="success" :loading="loading" class="qx09" @click="editAuth" v-on:keyup.13="editAuth()">提交</Button>
    </div>
  </div>
</template>

<script>
  import httpAuth from '@/api/auth';
  export default {
    name: "EditAuthName",
    data(){
      return{
        loading:false,      //是否显示加载状态
        name:'',            //权限名称
        order:'',           //权限顺序
        id:'',              //id
        icon:'',            //图标
      }
    },
    mounted() {
    },
    created() {
      var me = this;
      me.name = me.$route.params.name;
      me.id = me.$route.params.id;
      me.order = me.$route.params.code;
      me.icon = me.$route.params.icon;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.editAuth();
        }
      }
    },
    methods:{
      editAuth(){
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          companyId:user.companyId,
          id:me.id,
          name:me.name,
          code:me.order,
          icon:me.icon,
          type:0
        };
        httpAuth.editAuthName(data).then(res => {
          if (res.code == '1111') {
            me.$message.error("系统错误");
          } else {
            me.$message.success('修改成功');
            setTimeout(function () {
              me.$router.back();
            },1500)
          }
        })
      },
      back(){
        this.$router.back();
      }
    }
  }
</script>

<style scoped>
@import "AuthList.css";
</style>